import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChatUiService {
  private _closeAll$ = new Subject<void>();
  closeAll$ = this._closeAll$.asObservable();

  closeAll(): void {
    this._closeAll$.next();
  }
}
